// ----------------------------------------------------------------------
// <copyright file="Izenda.HeaderSection.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * HeaderSection component
 */
!(function () {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var connect = require('share/enhancers/Izenda.Connect');

  var Panel = require('share/components/controls/Izenda.Panel');
  var Header = require('./Izenda.Header');
  var Body = require('./Izenda.Body');
  var Footer = require('./Izenda.Footer');

  var HeaderSection = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired,
      item: React.PropTypes.object.isRequired
    },

    render: function () {
      var props = this.props;
      var detail = props.item;
      var detailStore = props.store;
      var header = {
        expanedOption: true,
        component: Header,
        detail: detail,
        detailStore: detailStore
      };
      var footer = {
        component: Footer,
        detail: detail
      };
      var isNew = detailStore.item.isNew;

      return isNew
      ? <div className='panel-heading workspace-header'><Header detail={detail} detailStore={detailStore}/></div>
      : (
        <Panel header={header}
               footer={footer}
               collapsible={true}
               className='header-section' >

              <Body {...this.props}/>
        </Panel>
      );

    }
  });

  module.exports = observer(connect({toClass: true})(HeaderSection));
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/HeaderSection/Izenda.HeaderSection.jsx